import styled, { css } from 'styled-components'
import {
  Box,
  Button,
  DropdownItem,
  FlatButton,
  truncateStyles,
} from '@sketch/components'
import { ReactComponent as Plus } from '@sketch/icons/plus-17'
import { ReactComponent as Link } from '@sketch/icons/markdown-link-share-17'
import { ReactComponent as Sliders } from '@sketch/icons/sliders-3-17'

export const TriggerButton = styled(Button).attrs({ size: '32' })(
  ({ theme }) => css`
    padding: 6px 8px 6px 12px; /* stylelint-disable-line scales/space */
    font-size: ${theme.fontSizes.D};
    font-weight: ${theme.fontWeights.regular};
    box-shadow: none;

    &,
    :hover,
    :focus,
    :active {
      color: ${theme.colors.foreground.secondary.A};
    }

    &[disabled] {
      opacity: 0.5;
    }

    &[aria-expanded='true'],
    &[aria-current='true'],
    &.active {
      border: 1px solid ${theme.colors.sketch.F};
      background-color: ${theme.colors.sketch.F};
      color: ${theme.colors.sketch.A};

      &:hover {
        background-color: ${theme.colors.sketch.F};
      }
    }
  `
)

export const DropdownItemStyled = styled(DropdownItem)(
  ({ theme }) => css`
    font-weight: ${theme.fontWeights.semibold};
  `
)

export const DropdownHeader = styled(Box)(
  ({ theme }) => css`
    margin-left: 20px;
    padding: 8px 0;

    color: ${theme.colors.foreground.secondary.D};
    font-size: ${theme.fontSizes.B};
    font-weight: ${theme.fontWeights.regular};

    text-align: left;
    pointer-events: none;
  `
)

export const DropdownItemDescription = styled.span(
  ({ theme }) => css`
    display: block;
    margin: 4px 0 0 0;
    line-height: 1.2;
    white-space: initial;
    color: ${theme.colors.foreground.secondary.D};
    font-size: ${theme.fontSizes.C};
    font-weight: ${theme.fontWeights.regular};
  `
)

export const PreviewHeader = styled(DropdownItem)(
  ({ theme }) => css`
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-right: 16px;
    font-weight: ${theme.fontWeights.regular};
    color: ${theme.colors.foreground.secondary.D};
    font-size: ${theme.fontSizes.B};
  `
)

const iconStyles = css`
  width: 17px;
  height: 17px;
  flex: none;
`

export const PlusIcon = styled(Plus)`
  ${iconStyles}
`

export const LinkIcon = styled(Link)`
  ${iconStyles}
`

export const SlidersIcon = styled(Sliders)`
  ${iconStyles}
`

export const ActionButton = styled(FlatButton)`
  padding: 8px 12px 8px;
`

export const ActionsWrapper = styled.div`
  display: flex;
  align-items: center;
  padding-right: 4px;
`

export const PreviewItem = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;

  ${truncateStyles};
  width: 100%;
  min-width: '150px';
  white-space: initial;

  padding-top: 8px;
  padding-bottom: 8px;
  padding-left: 20px;
  padding-right: 8px;
`

export const PreviewList = styled.div`
  & > div:first-child {
    padding-top: 0;
  }
`

export const ItemName = styled.span(
  ({ theme }) => css`
    color: ${theme.colors.foreground.secondary.B};
    font-size: ${theme.fontSizes.D};
    font-weight: ${theme.fontWeights.semibold};
    line-height: ${theme.lineHeights.default};
    text-align: left;
  `
)
